import * as React from "react";
import { IIdColorTitle } from "../../models/common/idColorTitle";
import { Base } from "../../framework/base";

export interface IEventEditUrgencyClassStateTextProp {
    urgencyClass: IIdColorTitle;
    thick?: boolean;
    wide?: boolean;
}

export class EventEditUrgencyClassStateText extends React.Component<IEventEditUrgencyClassStateTextProp, {}> {
    render() {
        const props = this.props;
        const backColor = props.urgencyClass?.color;
        const textColor = Base.invertColor(backColor);
        const bordered = Base.isWhite(backColor);
        return (<span
            className={"stateText" + (props.thick ? " thick" : "") + (props.wide ? " wide" : "")}
            style={{ backgroundColor: backColor, color: textColor, border: bordered ? "1px solid lightgray" : null, lineHeight: bordered ? "22px" : null }}>
            {props.urgencyClass?.title}
        </span>);
    }
}